import type { BitmapText } from "pixi.js";
import { forwardRef } from "react";
import type { Point2D } from "../types";

const OUTLINE_OFFSETS = [
    [-1, 0],
    [1, 0],
    [0, -1],
    [0, 1],
    [-1, -1],
    [1, -1],
    [-1, 1],
    [1, 1],
] as const;

// outlineOffset=1 preserves a one-unit offset at the original 48-unit font size.
const BASE_OUTLINE_FONT_SIZE = 48;

interface OutlinedBitmapTextProps {
    text: string;

    fontSize: number;
    fill?: string | number;
    outlineColor?: string | number;
    outlineOffset?: number;

    anchor?: Point2D;
    x?: number;
    y?: number;
}

const OutlinedBitmapText = forwardRef<BitmapText, OutlinedBitmapTextProps>(
    function OutlinedBitmapText(
        {
            text,
            fontSize,
            fill = "#ffffff",
            outlineColor = "#000000",
            outlineOffset = 1,
            anchor = { x: 0.5, y: 0.5 },
            x = 0,
            y = 0,
        },
        ref,
    ) {
        const style = {
            fontFamily: "MavenPro-Bold",
            fontSize,
            align: "center" as const,
        };
        const outlineThickness =
            (fontSize / BASE_OUTLINE_FONT_SIZE) * outlineOffset;

        return (
            <>
                {outlineThickness > 0 &&
                    OUTLINE_OFFSETS.map(([offsetX, offsetY]) => (
                        <pixiBitmapText
                            key={`${offsetX}-${offsetY}`}
                            eventMode="none"
                            text={text}
                            anchor={anchor}
                            x={x + offsetX * outlineThickness}
                            y={y + offsetY * outlineThickness}
                            style={{ ...style, fill: outlineColor }}
                        />
                    ))}
                <pixiBitmapText
                    ref={ref}
                    eventMode="none"
                    text={text}
                    anchor={anchor}
                    x={x}
                    y={y}
                    style={{ ...style, fill }}
                />
            </>
        );
    },
);

export default OutlinedBitmapText;
